import React from "react";
import { Link } from "react-router-dom";
import { LOGOS, BRANCH_LIST } from "@/lib/brand";
import { Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-[#070707] text-zinc-400" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src={LOGOS.groupe} alt="Equinoxe Groupe" className="h-14 w-14 object-contain" />
            <div>
              <div className="font-display text-xl text-white tracking-tight">EQUINOXE</div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">Groupe</div>
            </div>
          </div>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-zinc-500">
            Un groupe, trois expertises. Conseil aux entreprises, sûreté et propreté —
            trois pôles complémentaires pensés pour accompagner vos projets professionnels et privés.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Nos pôles</h4>
          <ul className="space-y-3 text-sm">
            {BRANCH_LIST.map((b) => (
              <li key={b.key}>
                <Link
                  to={`/${b.key}`}
                  className="hover:text-white transition-colors"
                  data-testid={`footer-link-${b.key}`}
                  style={{ color: b.accent }}
                >
                  {b.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-0.5 text-zinc-500" />
              <a href="tel:+33532189044" className="hover:text-white transition-colors">05 32 18 90 44</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 text-zinc-500" />
              <span>46000 CAHORS · 46250 CAZALS</span>
            </li>
            <li className="pt-2 space-y-2">
              <Link to="/contact" className="block text-white hover:underline" data-testid="footer-cta-contact">
                Demander un devis →
              </Link>
              <Link to="/espace-client/login" className="block text-zinc-400 hover:text-white text-xs" data-testid="footer-client-portal">
                Espace client →
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row gap-3 justify-between items-center text-xs text-zinc-600">
          <span>© {new Date().getFullYear()} Groupe Equinoxe — Tous droits réservés.</span>
          <span>Equinoxe Studio · Equinoxe Sécurité · Equinoxe Propreté</span>
        </div>
      </div>
    </footer>
  );
}
